import { useState, useEffect, useRef } from 'react';
import CategoryCheckbox from "./CategoryCheckbox";

const CategoryMultiSelect = ({ categories, disabled, onChange, customerType, onSelectCustomerType }) => {

    const scrollContainerRef = useRef(null);
    const [showLeftArrow, setShowLeftArrow] = useState(false);
    const [showRightArrow, setShowRightArrow] = useState(true);
    
    const handleScrollLeft = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollBy({
            top: 0,
            left: -100,
            behavior: 'smooth',
            });
        }
    };

    const handleScrollRight = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollBy({
            top: 0,
            left: 100,
            behavior: 'smooth',
            });
        }
    };

    const handleCheckboxChange = (category, active) => {        
        if (onChange) {
            onChange(category, active);
        }
    };

    const watchScroll = (e) => {
        if (scrollContainerRef.current) {
            setShowLeftArrow(scrollContainerRef.current.scrollLeft !== 0);
            setShowRightArrow(scrollContainerRef.current.scrollLeft + scrollContainerRef.current.clientWidth !== scrollContainerRef.current.scrollWidth);
        }
    }

    useEffect(() => {
        watchScroll();
        window.addEventListener('resize', watchScroll);
        return () => window.removeEventListener('resize', watchScroll);
    }, []);

    const selectCustomerType = (type) => {        
        if (onSelectCustomerType) {
            onSelectCustomerType(type);
        }
    }

    const calcHeight = () => {
        return !customerType ? '184px' : '75px';
    }

    return (        
        <div className='category-multi-select-container position-relative' style={{height: calcHeight()}}>

            { !customerType && (               
                <div className='category-multi-select-overlay-customer-type'>                                        
                    <div className="d-flex flex-column" style={{height:'100%'}}>
                        <div className="w-100 px-3" style={{marginBottom: "12px"}}>
                            <button onClick={() => {
                                if (typeof window.dataLayer !== 'undefined') {
                                    window.dataLayer.push({
                                        event: 'btn-map-zuhause'                    
                                    });  
                                }
                                selectCustomerType('B2C');
                            }} 
                                className='d-flex flex-row justify-content-between align-items-center customer-type-btn'>
                                <div className="customer-type-btn-icon d-flex justify-content-center align-items-center me-3">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"></path><path d="M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path></svg>
                                </div>
                                <div className="flex-fill d-flex flex-column align-items-start justify-content-between">
                                    <div style={{fontSize: "14px", marginBottom: "0.125rem", lineHeight: "20px"}}>Für Zuhause</div>
                                    <div style={{fontSize: "12px", color:"#99a1af"}}>Privatkunde</div>
                                </div>
                                {/* <div className="size-5 rounded-full flex items-center justify-center border-2 transition-colors bg-transparent border-gray-600"></div> */}
                            </button>
                        </div>
                        <div className="w-100 px-3">
                            <button onClick={() => {
                                if (typeof window.dataLayer !== 'undefined') {
                                    window.dataLayer.push({
                                        event: 'btn-map-gewerbe'                    
                                    });  
                                }
                                selectCustomerType('B2B');
                            }} 
                                className='d-flex flex-row justify-content-between align-items-center customer-type-btn'>
                                <div className="customer-type-btn-icon d-flex justify-content-center align-items-center me-3">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"></path><path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"></path><path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"></path><path d="M10 6h4"></path><path d="M10 10h4"></path><path d="M10 14h4"></path><path d="M10 18h4"></path></svg>
                                </div>
                                <div className="flex-fill d-flex flex-column align-items-start justify-content-between">
                                    <div style={{fontSize: "14px", marginBottom: "0.125rem", lineHeight: "20px"}}>Für Unternehmen</div>
                                    <div style={{fontSize: "12px", color:"#99a1af"}}>Geschäftskunde</div>
                                </div>
                                {/* <div className="size-5 rounded-full flex items-center justify-center border-2 transition-colors bg-transparent border-gray-600"></div> */}
                            </button>
                        </div>
                    </div>                   
                </div>
            )}
            
            {disabled && <div className="category-multi-select-overlay-disabled" />}   
            
            <div className='category-multi-select-overlay'>
                { showLeftArrow &&
                <span className='category-multi-select-overlay-arrow-left d-flex justify-content-start'>
                    <span className='d-flex align-items-center' onClick={handleScrollLeft}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-left" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"/>
                        </svg>
                    </span>
                </span>
                }
                { showRightArrow &&
                <span className='category-multi-select-overlay-arrow-right d-flex justify-content-end'>
                    <span className='d-flex align-items-center' onClick={handleScrollRight}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-right" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
                        </svg>
                    </span>
                </span>
                }
            </div>
            <div className='category-multi-select-content px-3 pb-2 d-flex justify-content-between align-items-center' ref={scrollContainerRef} onScroll={watchScroll}>
            {categories.map((category, index) => (
                <CategoryCheckbox
                    key={index}
                    category={category}                    
                    onChange={handleCheckboxChange}
                />
            ))}
            </div>
        </div>        
    );
};

export default CategoryMultiSelect;